import { Component, OnInit, Input, ViewChild, ElementRef, HostListener  } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { InterfaceIndicator } from '../../models/indicator.model';
import { CreateMesurementComponent } from '../create-mesurement/create-mesurement.component';
import { IndicatorDetailComponent } from '../indicator-detail/indicator-detail.component';
import { IndicatorService } from 'app/services/indicator.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SweetalertService } from 'app/services/sweetalert.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { timezone } from 'assets/constants/timezone';
import { finalize, take } from 'rxjs/operators';
import { PeriodIndicatorComponent } from '../period-indicator/period-indicator.component';
import { InterfaceMesurement } from 'app/models/mesurement.model';
import { NgxSpinnerService } from 'ngx-spinner';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
import * as isoWeek from 'dayjs/plugin/isoWeek';
import * as dayOfYear from 'dayjs/plugin/dayOfYear';
import Swal from 'sweetalert2';
import { Object } from 'core-js';
import {CdkDragDrop, moveItemInArray, CdkDrag} from '@angular/cdk/drag-drop';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);
dayjs.extend(isoWeek);
dayjs.extend(dayOfYear);

@Component({
  selector: 'app-indicator-mod',
  templateUrl: './indicator-table-mod.component.html',
  styleUrls: ['./indicator-table-mod.component.scss']
})
export class IndicatorTableModComponent implements OnInit {

  @ViewChild('filePlan', { static: true }) filePlan!: ElementRef;
  @ViewChild('fileCause', { static: true }) fileCause!: ElementRef;
  indicators: InterfaceIndicator[] = [];
  @Input() indicatorsIds: string[] = [];
  subscriptions: Subscription[] = [];
  currentWeek: number;
  currentYear: number;
  currentMonth: number;
  mesurements: any = {};
  isLoading = true;
  isUploadingFile = false;
  downloadURL: Observable<string> = new Observable;
  currentRow = -1;
  isUploadingCause = false;
  isUploadingPlan = false;
  currentPercentage = 0;
  startPeriodUnix: number;
  endPeriodUnix: number;
  startPeriod: string;
  endPeriod: string;
  togglePeriod = true;
  showContextMenu = false;
  contextmenuX = 0;
  contextmenuY = 0;
  selectedIndicator: InterfaceIndicator = {};
  showIndicatorPeriod = false;
  accumulates: any = {};
  monthName: string;
  orderInd = [];
  indicatorsIni = [];
  area = [];
  indicatorsTemp = [];
  limitedIndicators: InterfaceIndicator[] = [];


  constructor(
    protected indicatorService: IndicatorService,
    public modal: NgbModal,
    public swal: SweetalertService,
    protected storage: AngularFireStorage,
    private spinner: NgxSpinnerService
  ) {
    this.currentWeek = dayjs().tz(timezone).subtract(1, 'week').isoWeek();
    console.log("Semana actual: ",this.currentWeek)
    this.currentYear = dayjs().tz(timezone).year();
    this.startPeriodUnix = dayjs().tz(timezone).startOf('isoWeek').unix();
    this.endPeriodUnix = dayjs().tz(timezone).endOf('isoWeek').unix();
    this.startPeriod = dayjs().tz(timezone).startOf('isoWeek').format('DD/MM/YYYY');
    this.endPeriod = dayjs().tz(timezone).endOf('isoWeek').format('DD/MM/YYYY');
    this.currentMonth = Number(dayjs().tz(timezone).format('MM'));
  }

  editOrder(){
    this.indicatorsTemp = []
    let temp = JSON.stringify(this.indicators)
    this.indicatorsTemp = JSON.parse(temp)
    // this.indicators.forEach(val => this.indicatorsTemp.push(
    //   Object.assign([], val)
    //   ));
    document.getElementById('saveOrder').style.display = 'block'
    document.getElementById('cancelOrder').style.display = 'block'
    document.getElementById('editOrder').style.display = 'none'
    document.getElementById('colMov').style.display = ''

    const move = document.querySelectorAll('.movementOrder');

    move.forEach(element => {
      element.classList.replace('d-none','d-block');
    });
  }

  cancelOrder(){
    this.indicators = this.indicatorsTemp
    document.getElementById('saveOrder').style.display = 'none'
    document.getElementById('cancelOrder').style.display = 'none'
    document.getElementById('editOrder').style.display = 'block'
    document.getElementById('colMov').style.display = 'none'

    const move = document.querySelectorAll('.movementOrder');

    move.forEach(element => {
      element.classList.replace('d-block','d-none');
    });
  }

  saveOrder(){
    document.getElementById('saveOrder').style.display = 'none'
    document.getElementById('cancelOrder').style.display = 'none'
    document.getElementById('editOrder').style.display = 'block'
    document.getElementById('colMov').style.display = 'none'

    const move = document.querySelectorAll('.movementOrder');

    move.forEach(element => {
      element.classList.replace('d-block','d-none');
    });
    this.orderInd = [];
    this.area = [];
    this.arrayPosition()


    this.swal.showSuccessSaveOrder();
  }

  //Obtener el orden en el que se encuentran los indicadores
  arrayPosition(){
    // console.log(this.indicators[0])
    let indT = []
    for (let i = 0; i < this.indicators.length; i++) {
      indT.push(this.indicators[i])
      // console.log("Indicadores ",this.indicators[i][0])
    }
    // indT.push(this.indicators[0])
    console.log("indicadores ",indT)

    for(let y = 0; y < indT.length; y++){
      for(let i = 0; i < indT[y].length; i++){
        let areaPosc = 0
        for(let x = 0; x < indT[y][i].length; x++){
          this.orderInd.push([x + 1,this.indicators[y][i][x].id])
          this.area.push([i + 1,this.indicators[y][i][x].id])
        }
      }
    }



    // for(let i = 0; i < indT[0].length; i++){
    //   this.area.push([i + 1,this.indicators[0][i][0]["areaId"]])
    // }

    this.orderInd.forEach(element => {
      this.indicatorService.updateOrderIndicators(element[0], element[1])
    });

    this.area.forEach(element => {
      this.indicatorService.updateOrderAreas(element[0], element[1])
    });

  }


  drop(event: CdkDragDrop<InterfaceIndicator[]>,area) {

    let indT = []
    let indF = {}
    let indx = 0
    let deptIndx = 0
    let deptIndex = 0

    //Este recorre los departamentos
    for(deptIndx = 0; deptIndx < this.indicators.length; deptIndx++){
      indT.push(this.indicators[deptIndx])
      // Este for recorre las areas
      for(let i = 0; i < indT.length; i++){
        for(let x = 0; x < indT[i].length; x++ ){
          if(indT[i][x][0]["areaName"] == area){
            indx = x
            deptIndex = deptIndx
            return moveItemInArray(this.indicators[deptIndex][indx], event.previousIndex, event.currentIndex);
          }
        }
      }
    }
  }

  dropDep(event: CdkDragDrop<InterfaceIndicator[]>,dept,i) {
    let indT = []
    let indF = {}
    let indx
    indT.push(this.indicators[i])

    moveItemInArray(indT[0], event.previousIndex, event.currentIndex);
    this.indicators[i] = indT[0]
  }

  evenPredicate(item: CdkDrag<number>) {
    return item.data % 2 === 0;
  }

  ngOnInit(): void {
    this.getIndicators();
    // console.log(this.indicators)
  }

  /* FUNCION PARA CONOCER EL DIA DE LA SEMANA DE ALGUNA FECHA */
  weekDay(day, month, year): string{
    let days=["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
    let dt = new Date(day+' '+month+', '+year+' 12:00:00');
    return days[dt.getUTCDay()];
  };

  // get all the indicator information with the current mesurement showed
  getIndicators(data?: any): void {
    console.log("Año actual: ",this.currentYear)
    let splitDate: any;
    this.spinner.show(undefined,
      {
        type: 'square-jelly-box',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.isLoading = true;
    this.indicators = [];
    this.mesurements = {};
    let body = {
      indicatorsIds: this.indicatorsIds,
      startPeriodUnix: this.startPeriodUnix,
      endPeriodUnix: this.endPeriodUnix,
      filterBy: {
        weekOrMonth: this.togglePeriod ? 'weekNumber' : 'monthNumber',
        yearNumber: this.currentYear,
        numberWeekOrMonth: this.togglePeriod ? this.currentWeek : this.currentMonth,
      },
      period: 4
    };

    if (this.togglePeriod){
      splitDate = this.startPeriod.split("/");
      this.monthName = this.returnMonthFormat(splitDate[1] > 9 ? parseInt(splitDate[1]) : parseInt(splitDate[1].replace("0","")));
//      console.log('Arriba:' + this.monthName + this.currentMonth)
    }else{
      this.monthName = this.returnMonthFormat(this.currentMonth)
//      console.log('Abajo:' + this.monthName + this.currentMonth)
    }

    body = data == undefined ? body : data;

    console.log("Body: ",body)
    this.indicatorService.getActiveIndicators(body).pipe(take(1)).subscribe((result: any) => {
      if (result && result.body) {
        this.indicators = result.body.indicators;
        this.mesurements = result.body.mesurements;
      }

      console.log("Indicadores: ",this.indicators)
      this.isLoading = false;
      this.spinner.hide();
      this.scrollToTop();
    }, (error: any) => {
      console.error(error);
      this.spinner.hide();
    });
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }

  // returns the format changed to $, % and #
  returnChangedFormat(indicatorType: number, amount: number): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
    switch (indicatorType) {
      case 1:
        if (amount) {
          return formatter.format(amount);
        } else {
          return formatter.format(0);
        }
      case 2:
        if (amount) {
          return amount + '%'
        } else {
          return '0%'
        }
      case 3:
        if (amount) {
          return amount.toString()
        } else {
          return '0';
        }
      default:
        return '';
    }
  }

  // return the current accumulated
  returnAccumulated(indicator: InterfaceIndicator): string {
    if (indicator.type === 1) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      let amount = 0;
      Object.keys(indicator.results).forEach((key: string) => {
        amount += indicator.results[key];
      });
      return formatter.format(amount);
    } else {
      return '';
    }
  }

  // open modal to create new mesurement
  addMesurement(indicator: InterfaceIndicator, type: string): void {
    console.log('Año actual: ', this.currentYear)
    const modalRef = this.modal.open(CreateMesurementComponent, {
      centered: true,
      backdrop: 'static',
      animation: true
    });
    modalRef.componentInstance.data = {
      indicator,
      currentMesurement: this.mesurements[indicator.id!],
      mesurementType: type,
      currWeek: this.currentWeek,
      currMonth: this.currentMonth,
      currYear: this.currentYear
    };
    modalRef.result.then((result: any) => {
      if (result && result.success) {
        this.swal.showSuccess();
        this.mesurements[indicator.id!] = result.mesurement;
        this.reloadMesurement(indicator, this.mesurements[indicator.id!], 0);
      } else if (result && !result.success) {
        this.swal.showError();
      } else {
        this.swal.showCancel();
      }
    }).catch((error: any) => {
      console.error(error);
      this.swal.showError();
    });
  }

  // reload the object of the mesurement edited
  reloadMesurement(indicator: InterfaceIndicator, mesurement: InterfaceMesurement, timesRunned: number): void {
    setTimeout(() => {
      this.indicatorService.getMesurement(indicator.id!, mesurement.yearNumber, mesurement.weekNumber).pipe(take(1)).subscribe((result: any) => {
        this.mesurements[indicator.id!] = result[0];
        if (!this.mesurements[indicator.id!].lineChartColumns && timesRunned < 5) {
          this.reloadMesurement(indicator, mesurement, timesRunned + 1);
        } else {
          const isMonth = this.mesurements[indicator.id].weekNumber ? false : true;
          const goal = indicator.goal === 0 ? 1 : indicator.goal;
          const redZone = Math.round(goal);
          const greenZone = Math.round(goal * 0.2);
          const label1 = isMonth ? this.returnMonthFormat(this.mesurements[indicator.id].pastResults.currentResult.weekOrMonthNumber) : 'S' + this.mesurements[indicator.id].pastResults.currentResult.weekOrMonthNumber;
          const label2 = isMonth ? this.returnMonthFormat(this.mesurements[indicator.id].pastResults.firstResult.weekOrMonthNumber) : 'S' + this.mesurements[indicator.id].pastResults.firstResult.weekOrMonthNumber;
          const label3 = isMonth ? this.returnMonthFormat(this.mesurements[indicator.id].pastResults.secondResult.weekOrMonthNumber) : 'S' + this.mesurements[indicator.id].pastResults.secondResult.weekOrMonthNumber;
          const label4 = isMonth ? this.returnMonthFormat(this.mesurements[indicator.id].pastResults.thirdResult.weekOrMonthNumber) : 'S' + this.mesurements[indicator.id].pastResults.thirdResult.weekOrMonthNumber;
          const tooltip1 = '<p style=\'font-size: 22px;\'>' + label1 + ': ' + this.returnChangedFormat(indicator.type, this.mesurements[indicator.id].pastResults.currentResult.value) + '</p>';
          const tooltip2 = '<p style=\'font-size: 22px;\'>' + label2 + ': ' + this.returnChangedFormat(indicator.type, this.mesurements[indicator.id].pastResults.firstResult.value) + '</p>';
          const tooltip3 = '<p style=\'font-size: 22px;\'>' + label3 + ': ' + this.returnChangedFormat(indicator.type, this.mesurements[indicator.id].pastResults.secondResult.value) + '</p>';
          const tooltip4 = '<p style=\'font-size: 22px;\'>' + label4 + ': ' + this.returnChangedFormat(indicator.type, this.mesurements[indicator.id].pastResults.thirdResult.value) + '</p>';
          this.mesurements[this.mesurements[indicator.id].indicatorId].lineChartData = [
            [label4, this.mesurements[indicator.id].pastResults.thirdResult.value, tooltip4, redZone, greenZone],
            [label3, this.mesurements[indicator.id].pastResults.secondResult.value, tooltip3, redZone, greenZone],
            [label2, this.mesurements[indicator.id].pastResults.firstResult.value, tooltip2, redZone, greenZone],
            [label1, this.mesurements[indicator.id].pastResults.currentResult.value, tooltip1, redZone, greenZone]
          ];
          this.mesurements[indicator.id].lineChartColumns = [
            {
              type: 'string',
              label: 'Periodo',
              role: 'domain'
            },
            {
              type: 'number',
              label: 'Resultado',
              role: 'data'
            },
            {
              type: 'string',
              role: 'tooltip',
              p: { html: true }
            },
            {
              type: 'number',
              label: 'Meta',
              role: 'data'
            },
            {
              type: 'number',
              label: 'Meta plus',
              role: 'data'
            }
          ];
          this.mesurements[indicator.id].lineChartOptions = {
            legend: 'none',
            isStacked: true,
            backgroundColor: 'transparent',
            tooltip: {
              isHtml: true,
              textStyle: {
                fontSize: 22
              }
            },
            vAxis: {
              minValue: 0,
              maxValue: Math.round((indicator.goal === 0 ? 1 : indicator.goal) * 1.2),
              viewWindow: {
                min: 0,
                max: Math.round((indicator.goal === 0 ? 1 : indicator.goal) * 1.2)
              }
            },
            hAxis: {
              minValue: this.mesurements[indicator.id].pastResults.currentResult.weekOrMonthNumber - 4,
              maxValue: this.mesurements[indicator.id].pastResults.currentResult.weekOrMonthNumber + 1
            },
            series: {
              0: {
                type: 'line',
                visibleInLegend: false,
                pointSize: 4
              },
              1: {
                lineWidth: 0,
                type: 'area',
                visibleInLegend: false,
                enableInteractivity: false,
                color: indicator.checkType === 1 ? 'red' : 'green'
              },
              2: {
                lineWidth: 0,
                type: 'area',
                visibleInLegend: false,
                enableInteractivity: false,
                color: indicator.checkType === 1 ? 'green' : 'red'
              }
            }
          };
          this.mesurements[indicator.id].gaugeChartData = [
            ['Result', this.mesurements[indicator.id].result]
          ];
          this.mesurements[indicator.id].gaugeChartOptions = {
            min: 0,
            max: indicator.goal < 1 ? 1 : indicator.goal * 1.2,
            greenFrom: indicator.checkType === 1 ? (indicator.goal < 1 ? 1 : indicator.goal) : 0,
            greenTo: indicator.checkType === 1 ? (indicator.goal < 1 ? 1.2 : indicator.goal * 1.2) : indicator.goal + 1,
            redFrom: indicator.checkType === 1 ? 0 : (indicator.goal < 1 ? 1 : indicator.goal),
            redTo: indicator.checkType === 1 ? indicator.goal + 1 : (indicator.goal < 1 ? 1.2 : indicator.goal * 1.2),
            yellowFrom: 0,
            yellowTo: 0,
            minorTicks: 20
          };
        }
      }, (error: any) => {
        console.error(error);
      });
    }, 1000);
  }

  // upload file of the plan in the indicator
  uploadFilePlan(target: any): void {
    let fileUploadSub: Subscription;
    this.isUploadingCause = false;
    this.isUploadingFile = true;
    this.isUploadingPlan = true;
    this.currentPercentage = 0;
    // getting the file uploaded
    const file = target.files[0];
    // creating the path for the storage
    const filePath = `Indicators/${this.selectedIndicator.id}/${Date.now()}`;
    // reference to storage
    const fileRef = this.storage.ref(filePath);
    // object to upload the file
    const task = this.storage.upload(filePath, file);
    // checking status of the upload
    fileUploadSub = task.percentageChanges().subscribe((percentage: any) => {
      this.currentPercentage = percentage;
    }, (error: any) => {
      console.error(error);
    });
    this.subscriptions.push(
      task.snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.subscriptions.push(
            // getting the url to download
            this.downloadURL.subscribe(url => {
              if (url) {
                fileUploadSub.unsubscribe();
                this.mesurements[this.selectedIndicator.id!].urlFilePlan! = url;
                this.updateMesurement(this.mesurements[this.selectedIndicator.id!]);
                this.isUploadingCause = false;
                this.isUploadingFile = false;
                this.isUploadingPlan = false;
              }
            }, (error: any) => {
              console.error(error);
            })
          );
        })
      ).subscribe((subscribeResult: any) => {
        console.log(subscribeResult);
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  // upload file of cause in the indicator
  uploadFileCause(target: any): void {
    let fileUploadSub: Subscription;
    this.isUploadingCause = true;
    this.isUploadingFile = true;
    this.isUploadingPlan = false;
    this.currentPercentage = 0;
    // getting the file uploaded
    const file = target.files[0];
    // creating the path for the storage
    const filePath = `Indicators/${this.selectedIndicator.id}/${Date.now()}`;
    // reference to storage
    const fileRef = this.storage.ref(filePath);
    // object to upload the file
    const task = this.storage.upload(filePath, file);
    fileUploadSub = task.percentageChanges().subscribe((percentage: any) => {
      this.currentPercentage = percentage;
    }, (error: any) => {
      console.error(error);
    });
    // checking status of the upload
    this.subscriptions.push(
      task.snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.subscriptions.push(
            // getting the url to download
            this.downloadURL.subscribe(url => {
              if (url) {
                fileUploadSub.unsubscribe();
                this.mesurements[this.selectedIndicator.id!].urlFileCause! = url;
                this.updateMesurement(this.mesurements[this.selectedIndicator.id!]);
                this.isUploadingCause = false;
                this.isUploadingFile = false;
                this.isUploadingPlan = false;
              }
            }, (error: any) => {
              console.error(error);
            })
          );
        })
      ).subscribe((subscribeResult: any) => {
        console.log(subscribeResult);
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  deleteFile(mesurement: InterfaceMesurement, key: string): void {
    const updateMesurementObj = Object.assign({}, mesurement);
    updateMesurementObj.lineChartColumns = {};
    updateMesurementObj.lineChartData = {};
    updateMesurementObj.lineChartOptions = {};
    updateMesurementObj.gaugeChartData = {};
    updateMesurementObj.gaugeChartOptions = {};
    updateMesurementObj[key] = null;
    this.indicatorService.updateMesurement(updateMesurementObj).then(() => {
      this.swal.showSuccess();
      this.mesurements[mesurement.indicatorId] = Object.assign(updateMesurementObj, mesurement);
      this.mesurements[mesurement.indicatorId][key] = null;
    }).catch((error: any) => {
      console.error(error);
      this.swal.showError();
    });
  }

  // update the mesurement edited
  updateMesurement(mesurement: InterfaceMesurement): void {
    const updateMesurementObj = Object.assign({}, mesurement);
    updateMesurementObj.lineChartColumns = {};
    updateMesurementObj.lineChartData = {};
    updateMesurementObj.lineChartOptions = {};
    updateMesurementObj.gaugeChartData = {};
    updateMesurementObj.gaugeChartOptions = {};
    this.indicatorService.updateMesurement(updateMesurementObj).then(() => {
      this.swal.showSuccess();
      this.currentRow = 0;
      this.isUploadingCause = false;
      this.isUploadingPlan = false;
      this.isUploadingFile = false;
      this.mesurements[mesurement.indicatorId] = Object.assign(updateMesurementObj, mesurement);
    }).catch((error: any) => {
      console.error(error);
      this.swal.showError();
    });
  }

  // download the file of plan or cause
  downloadFile(url: string): void {
    window.open(url);
  }

  // return the badge priority
  getClassBadgePriority(priority: string): string {
    switch (priority) {
      case 'AAA':
        return 'badge-danger'
      case 'AA':
        return 'badge-warning'
      case 'A':
        return 'badge-info'
      default:
        return 'badge-secondary'
    }
  }

  // get the indicators of the selected date
  setSelectedDate(date: string): void {
    this.startPeriod = dayjs(date, 'YYYYY-MM-DD').tz(timezone).startOf('isoWeek').format('DD/MM/YYYY');
    this.endPeriod = dayjs(date, 'YYYYY-MM-DD').tz(timezone).endOf('isoWeek').format('DD/MM/YYYY');
    this.startPeriodUnix = dayjs(date, 'YYYYY-MM-DD').tz(timezone).startOf('isoWeek').unix();
    this.endPeriodUnix = dayjs(date, 'YYYYY-MM-DD').tz(timezone).endOf('isoWeek').unix();
    this.currentYear = dayjs(date, 'YYYYY-MM-DD').tz(timezone).get('year');
    this.currentWeek = dayjs(date, 'YYYYY-MM-DD').tz(timezone).isoWeek();
    this.togglePeriod = true;
    this.getIndicators();
  }

  // get the number of the previus week
  getLastWeek(): void {
    if (this.currentWeek === 1) {
      this.currentWeek = 52;
      this.currentYear--;
    } else {
      this.currentWeek--;
    }
    this.setValuesWeek();
    this.getIndicators();
  }

  // get the current Week and year
  getCurrentWeek(): void {
    this.currentWeek = dayjs().tz(timezone).isoWeek();
    this.currentYear = dayjs().tz(timezone).year();
    this.startPeriodUnix = dayjs().tz(timezone).startOf('isoWeek').unix();
    this.endPeriodUnix = dayjs().tz(timezone).endOf('isoWeek').unix();
    this.startPeriod = dayjs().tz(timezone).startOf('isoWeek').format('DD/MM/YYYY');
    this.endPeriod = dayjs().tz(timezone).endOf('isoWeek').format('DD/MM/YYYY');
    this.getIndicators();
  }

  // get the number of the next week
  getNextWeek(): void {
    if (this.currentWeek === 52) {
      this.currentWeek = 1;
      this.currentYear++;
    } else {
      this.currentWeek++;
    }
    this.setValuesWeek();
    this.getIndicators();
  }

  // set the values of the week
  setValuesWeek(): void {
    this.startPeriod = dayjs().year(this.currentYear).startOf('year').add(this.currentWeek, 'week').startOf('isoWeek').format('DD/MM/YYYY');
    this.endPeriod = dayjs().year(this.currentYear).startOf('year').add(this.currentWeek, 'week').endOf('isoWeek').format('DD/MM/YYYY');
    this.startPeriodUnix = dayjs().year(this.currentYear).startOf('year').add(this.currentWeek, 'week').startOf('isoWeek').unix();
    this.endPeriodUnix = dayjs().year(this.currentYear).startOf('year').add(this.currentWeek, 'week').endOf('isoWeek').unix();
  }

  // set the values of the month
  setValuesMonth(): void {
    this.startPeriod = dayjs().year(this.currentYear).startOf('year').add(this.currentMonth - 1, 'month').startOf('month').format('DD/MM/YYYY');
    this.endPeriod = dayjs().year(this.currentYear).startOf('year').add(this.currentMonth - 1, 'month').endOf('month').format('DD/MM/YYYY');
    this.startPeriodUnix = dayjs().year(this.currentYear).startOf('year').add(this.currentMonth - 1, 'month').startOf('month').unix();
    this.endPeriodUnix = dayjs().year(this.currentYear).startOf('year').add(this.currentMonth - 1, 'month').endOf('month').unix();
  }

  // get the last month data
  getLastMonth(): void {
    if (this.currentMonth === 1) {
      this.currentMonth = 12;
      this.currentYear--;
    } else {
      this.currentMonth--;
    }
    this.setValuesMonth();
    this.getIndicators();
  }

  // get the current month data
  getCurrentMonth(): void {
    this.currentYear = dayjs().tz(timezone).year();
    // this.startPeriodUnix = dayjs().tz(timezone).startOf('isoWeek').unix();
    // this.endPeriodUnix = dayjs().tz(timezone).endOf('isoWeek').unix();
    // this.startPeriod = dayjs().tz(timezone).startOf('isoWeek').format('DD/MM/YYYY');
    // this.endPeriod = dayjs().tz(timezone).endOf('isoWeek').format('DD/MM/YYYY');
    this.setValuesMonth();
    this.getIndicators();
  }

  // get the next month data
  getNextMonth(): void {
    if (this.currentMonth === 12) {
      this.currentMonth = 1;
      this.currentYear++;
    } else {
      this.currentMonth++;
    }
    this.setValuesMonth();
    this.getIndicators();
  }

  // return month name
  returnMonthFormat(monthNumber: number): string {
    switch (monthNumber) {
      case 1:
        return 'Enero';
      case 2:
        return 'Febrero';
      case 3:
        return 'Marzo';
      case 4:
        return 'Abril';
      case 5:
        return 'Mayo';
      case 6:
        return 'Junio';
      case 7:
        return 'Julio';
      case 8:
        return 'Agosto';
      case 9:
        return 'Septiembre';
      case 10:
        return 'Octubre';
      case 11:
        return 'Noviembre';
      case 12:
        return 'Diciembre';
      default:
        return 'Error';
    }
  }

  // switchs the toggle button
  switchDisplayIndicators(): void {
    this.togglePeriod = !this.togglePeriod;
    if (this.togglePeriod) {
      this.getCurrentWeek();
    } else {
      this.getCurrentMonth();
    }
  }

  // open modal of history indicator to view all changes
  viewHistoryIndicator(indicator: InterfaceIndicator): void {
    const modalRef = this.modal.open(IndicatorDetailComponent, {
      centered: true,
      backdrop: 'static',
      animation: true,
      size: 'xl'
    });
    modalRef.componentInstance.data = {
      indicator: indicator,
      mesurementType: 'weekly'
    }
  }

  // opens the custom context menu and choose the option
  checkContextMenuAction(action: number): void {
    this.showContextMenu = false;
    switch (action) {
      case 1:
        this.addMesurement(this.selectedIndicator, 'weekly');
        break;
      case 2:
        const modalRef = this.modal.open(IndicatorDetailComponent, {
          centered: true,
          backdrop: 'static',
          animation: true
        });
        modalRef.componentInstance.data = {
          indicator: this.selectedIndicator,
          mesurementType: 'weekly'
        }
        break;
      case 3:
        this.addMesurement(this.selectedIndicator, 'monthly');
        break;
      case 4:
        this.showIndicatorPeriod = true;
        break;
      default:
        break;
    }
  }

  // open the input type file to upload files
  selectInputFile(indicator: InterfaceIndicator, index: number, flag: boolean): void {
    this.currentRow = index;
    this.selectedIndicator = indicator;
    if (flag) {
      this.fileCause.nativeElement.click();
    } else {
      this.filePlan.nativeElement.click();
    }
  }

  // return the accumulated class with the bg color
  getClassAccumulated(indicator: InterfaceIndicator): string {
    if (indicator.type === 2) {
      return '';
    } else {
      let amount = 0;
      Object.keys(indicator.results).forEach((key: string) => {
        amount += indicator.results[key];
      });
      if (amount >= indicator.goal!) {
        return 'greenBg';
      } else {
        return 'redBg';
      }
    }
  }

  // opens modal of the period indicator component
  openPeriod(indicator: InterfaceIndicator): void {
    const modalRef = this.modal.open(PeriodIndicatorComponent, {
      centered: true,
      size: 'xl',
      backdrop: 'static',
      animation: true
    });
    modalRef.componentInstance.indicator = indicator;
  }

  // returns the bg color of the result
  getClassCell(indicator: InterfaceIndicator): string {
    if (indicator.checkType === 1) {
      if (indicator.monthgoal[this.monthName] <= this.mesurements[indicator.id].result) {
        return 'greenCell';
      } else {
        return 'redCell';
      }
    } else {
      if (indicator.monthgoal[this.monthName] >= this.mesurements[indicator.id].result) {
        return 'greenCell';
      } else {
        return 'redCell';
      }
    }
  }

  editMesurement(indicator: InterfaceIndicator, index: number): void {

  }

  copyIndicators(): void {
    let contador = 0;
    let newMesurement;
    let data = {
      indicatorsIds: this.indicatorsIds,
      startPeriodUnix: this.startPeriodUnix,
      endPeriodUnix: this.endPeriodUnix,
      filterBy: {
        weekOrMonth: this.togglePeriod ? 'weekNumber' : 'monthNumber',
        yearNumber: this.currentYear,
        numberWeekOrMonth: this.togglePeriod ? this.currentWeek-1 : this.currentMonth-1,
      },
      period: 4
    };
    Swal.fire({
      title: this.togglePeriod ? "¿Deseas copiar los resultados de la semana ANTERIOR?" : "¿Deseas copiar los resultados del mes ANTERIOR?",
      html: this.togglePeriod ? "La información que ves en la pantalla de la <b>Semana "+(this.currentWeek)+" </b> será sustituida por los resultados de la <b>Semana "+(this.currentWeek - 1)+" </b>" : "La información que ves en la pantalla del Mes de <b>"+this.returnMonthFormat(this.currentMonth)+" </b> será sustituida por los resultados del Mes de <b> "+ this.returnMonthFormat(this.currentMonth - 1)+" </b>",
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.getIndicators(data);
        setTimeout(() => {
          let lastMesurements = Object.values(this.mesurements);
          for (let i = 0 ; i < lastMesurements.length ; i++){
            let iterableMesurement = lastMesurements[i];
            if (iterableMesurement != false){
              if (this.togglePeriod){
                /* SE HACE UNA CONSULTA A FIREBASE PARA TRAER LOS DATOS DEL MESUREMENT CORRESPONDIENTE */
                this.indicatorService.getMesurement(iterableMesurement.indicatorId, iterableMesurement.yearNumber, iterableMesurement.weekNumber).pipe(take(1)).subscribe((result: any) => {
                  newMesurement = result[0];

                  /* SE MODIFICAN LOS VALORES PARA CREAR EL NUEVO MESUREMENT */
                  newMesurement.createdByName = localStorage.userName + " - copia"
                  newMesurement.createdAt= dayjs().tz(timezone).unix();
                  newMesurement.id = this.indicatorService.createId();
                  newMesurement.weekNumber = this.currentWeek;
                  newMesurement.pastResults.thirdResult.value = newMesurement.pastResults.secondResult.value;
                  newMesurement.pastResults.thirdResult.weekOrMonthNumber = newMesurement.pastResults.secondResult.weekOrMonthNumber;
                  newMesurement.pastResults.secondResult.value = newMesurement.pastResults.firstResult.value;
                  newMesurement.pastResults.secondResult.weekOrMonthNumber = newMesurement.pastResults.firstResult.weekOrMonthNumber;
                  newMesurement.pastResults.firstResult.value = newMesurement.pastResults.currentResult.value;
                  newMesurement.pastResults.firstResult.weekOrMonthNumber = newMesurement.pastResults.currentResult.weekOrMonthNumber;
                  newMesurement.pastResults.currentResult.weekOrMonthNumber = this.currentWeek;

                  /* SE HACE EL INSERT DEL NUEVO MESUREMENT */
                  this.indicatorService.createMesurement(newMesurement).then(() => { }).catch((error: any) => {
                    this.swal.showError("Error");
                    console.error('Error creating mesurement =>', error);
                  });
                }, (error: any) => {
                  console.error(error);
                })
              }else{
                this.indicatorService.getMesurementByMonth(iterableMesurement.indicatorId, iterableMesurement.yearNumber, iterableMesurement.monthNumber).pipe(take(1)).subscribe((result: any) => {
                  newMesurement = result[0];

                  /* SE MODIFICAN LOS VALORES PARA CREAR EL NUEVO MESUREMENT */
                  newMesurement.createdByName = localStorage.userName + " - copia"
                  newMesurement.createdAt= dayjs().tz(timezone).unix();
                  newMesurement.id = this.indicatorService.createId();
                  newMesurement.monthNumber = this.currentMonth;
                  newMesurement.pastResults.thirdResult.value = newMesurement.pastResults.secondResult.value;
                  newMesurement.pastResults.thirdResult.weekOrMonthNumber = newMesurement.pastResults.secondResult.weekOrMonthNumber;
                  newMesurement.pastResults.secondResult.value = newMesurement.pastResults.firstResult.value;
                  newMesurement.pastResults.secondResult.weekOrMonthNumber = newMesurement.pastResults.firstResult.weekOrMonthNumber;
                  newMesurement.pastResults.firstResult.value = newMesurement.pastResults.currentResult.value;
                  newMesurement.pastResults.firstResult.weekOrMonthNumber = newMesurement.pastResults.currentResult.weekOrMonthNumber;
                  newMesurement.pastResults.currentResult.weekOrMonthNumber = this.currentMonth;

                  /* SE HACE EL INSERT DEL NUEVO MESUREMENT */
                  this.indicatorService.createMesurement(newMesurement).then(() => { }).catch((error: any) => {
                    this.swal.showError("Error");
                    console.error('Error creating mesurement =>', error);
                  });
                }, (error: any) => {
                  console.error(error);
                })
              }
            }else{
              contador++;
            }
          }
          contador == lastMesurements.length ? this.swal.showError("No hay datos para copiar"): this.swal.showSuccess("Se han copiado correctamente");
        }, 4000);
      }
    })
  }
}
